import type { ReactNode } from 'react';
import type { Screen } from '../../types';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface Props {
  screen: Screen;
  onNav: (screen: Screen) => void;
  previewMode: boolean;
  onTogglePreview: () => void;
  children: ReactNode;
}

export function AppLayout({ screen, onNav, previewMode, onTogglePreview, children }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        height: '100vh',
        background: 'var(--surface)',
      }}
    >
      <Sidebar current={screen} onNav={onNav} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <TopBar
          current={screen}
          onNav={onNav}
          previewMode={previewMode}
          onTogglePreview={onTogglePreview}
        />
        {children}
      </div>
    </div>
  );
}
